export default "__VITE_ASSET__3c79459a__"